<template>
  <div class="login">
    <!-- Imagem de Fundo -->
    <div class="background" :style="backgroundStyle"></div>

    <!-- Conteúdo Central -->
    <div class="login-container">
      <!-- Cabeçalho -->
      <header class="header">
        <img
          v-if="logoUrl"
          :src="logoUrl"
          alt="Logomarca"
          class="logo"
          @error="onImgError"
        />
        <h6>Seja bem-vindo!</h6>
      </header>

      <!-- Formulário de Login -->
      <form class="login-form" @submit.prevent="login">
        <div class="form-group">
          <label for="email">E-mail</label>
          <input type="email" v-model="email" id="email" required />
        </div>
        <div class="form-group">
          <label for="password">Senha</label>
          <div class="input-with-icon">
            <input
              :type="showLoginPassword ? 'text' : 'password'"
              v-model="password"
              id="password"
              class="form-control pe-5"
              required
              autocomplete="current-password"
            />
            <button
              type="button"
              class="toggle-visibility"
              :aria-pressed="showLoginPassword ? 'true' : 'false'"
              :title="showLoginPassword ? 'Ocultar senha' : 'Mostrar senha'"
              @click="showLoginPassword = !showLoginPassword"
            >
              <i :class="showLoginPassword ? 'bi bi-eye-slash-fill' : 'bi bi-eye-fill'"></i>
            </button>
          </div>
        </div>
        <button
          type="submit"
          :class="['btn', isLogging ? 'btn-success' : 'btn-primary']"
          :disabled="isLogging"
        >
          {{ isLogging ? 'Acessando…' : 'Acessar' }}
        </button>
        <a href="#" class="forgot-password" @click.prevent="showModal = true">
          Esqueceu a senha?
        </a>
      </form>

      <!-- Rodapé -->
      <footer class="footer">
        <p>&copy; {{ currentYear }} - TOQ Soluções / Khodr & Cabral</p>
        <a href="#">Termos de uso</a>
        <div class="social-icons">
          <a href="#"><i class="fab fa-whatsapp"></i></a>
          <a href="#"><i class="fab fa-facebook"></i></a>
          <a href="#"><i class="fab fa-instagram"></i></a>
          <a href="#"><i class="fab fa-linkedin"></i></a>
        </div>
      </footer>
    </div>
    <ForgotPasswordModal
      :visible="showModal"
      @close="showModal = false"
    />
  </div>
</template>


<script>
import axios from "@/services/axios";
import ForgotPasswordModal from '@/views/ForgotPasswordModal.vue';
// import globalUtils from "@/utils/globalUtils"; // garante acesso aos helpers

// console.log('estou aq', )

export default {
  components: { ForgotPasswordModal },
  name: "LoginPage",
  data() {
    return {
      email: "",
      password: "",
      errorMessage: "",
      isLogging: false,
      showModal: false,
      // chave local para cache-busting (fixa por montagem)
      cacheKey: Date.now(),
      showLoginPassword: false,
    };
  },
  computed: {
    currentYear() {
      return new Date().getFullYear();
    },
    // URL absoluta da logomarca ('' se não houver)
    
    // Já armazenamos no globalState as URLs COMPLETAS (com cache-buster)
    logoUrl() {
      return this.$globalState?.logoPath || '';
    },
    backgroundStyle() {
      const url = this.$globalState?.backgroundPath || '';
      return url ? { backgroundImage: `url('${url}')` } : {};
    }

  },
 
  mounted() {
    // Certifique-se de que os caminhos estão carregados ao montar a página
    // console.log("Logomarca carregada:", this.$globalState.logoPath);
    // console.log("Plano de fundo carregado:", this.$globalState.backgroundPath);
  },
  methods: {

    onImgError(e) {
      e.target.src =
        "data:image/svg+xml;utf8," +
        encodeURIComponent(
          `<svg xmlns='http://www.w3.org/2000/svg' width='240' height='80'>
             <rect width='100%' height='100%' fill='#f2f2f2'/>
             <text x='50%' y='50%' dominant-baseline='middle' text-anchor='middle'
                   font-family='sans-serif' font-size='14' fill='#888'>
               sem logomarca
             </text>
           </svg>`
        );
    },

    validateInputs() {
      if (!this.email || !this.email.includes("@")) {
        this.$toast.error("Insira um e-mail válido.");
        return false;
      }
      if (!this.password || this.password.length < 6) {
        this.$toast.error("A senha deve ter pelo menos 6 caracteres.");
        return false;
      }
      this.errorMessage = "";
      return true;
    },

    async login() {
      if (!this.validateInputs()) return;
      this.isLogging = true;

      try {
        // usa a instância com baseURL resolvido
        const { data, status } = await axios.post('/auth/login', {
          email: this.email.trim(),
          password: this.password,
        });

        // DEBUG temporário (remova depois)
        // console.log('LOGIN RESP', status, request?.responseURL, data);

        if (status === 200 && data && data.token) {
          // guarda token e permissões
          localStorage.setItem('token', data.token);
          if (Array.isArray(data.permissions)) {
            localStorage.setItem('permissions', JSON.stringify(data.permissions));
          }
          // define Authorization global
          axios.defaults.headers.common.Authorization = `Bearer ${data.token}`;

          // opcional: extrair exp sem quebrar fluxo
          const exp = (() => {
            try {
              const [, p] = data.token.split('.');
              const b64 = p.replace(/-/g, '+').replace(/_/g, '/')
                          .padEnd(Math.ceil(p.length / 4) * 4, '=');
              return JSON.parse(atob(b64))?.exp ?? null;
            } catch { return null; }
          })();
          if (exp) localStorage.setItem('token_exp', String(exp));

          await this.$router.push('/dashboard');
          return;
        }

        // se não veio token, trata como erro de credencial
        this.$toast.error('E-mail ou senha incorretos.');
      } catch (err) {
        if (err?.response?.status === 401) {
          this.$toast.error('E-mail ou senha incorretos.');
        } else {
          const msg = err?.response?.data?.message || err?.message || 'Erro ao autenticar.';
          this.$toast.error(msg);
        }
      } finally {
        this.isLogging = false;
      }
    },

    // helper: decodifica Base64URL com padding e falha silenciosa
    decodeJwtExpSafely(token) {
      try {
        const [, payloadB64] = token.split('.');
        if (!payloadB64) return null;
        const base64 = payloadB64.replace(/-/g, '+').replace(/_/g, '/')
          .padEnd(Math.ceil(payloadB64.length / 4) * 4, '=');
        const json = atob(base64);
        const payload = JSON.parse(json);
        return payload?.exp ?? null;
      } catch {
        return null;
      }
    }
  },
};
</script>



<style scoped>
/* .login {
  position: relative;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #333;
  font-family: Arial, sans-serif;
} */

.login {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh; /* Ocupa 100% da altura da tela */
  width: 100vw; /* Ocupa 100% da largura da tela */
  /* background-color: #f7f9fc; Fundo neutro */
  margin: 0;
  padding: 0;
}

.background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center;
  filter: blur(5px);
  z-index: -1;
}

.login-container {
  background: rgba(255, 255, 255, 0.9);
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);
  max-width: 400px;
  width: 100%;
  text-align: center;
}

.logo {
  max-width: 220px;
  width: 100%;
  max-height: 110px;     /* ajusta conforme teu layout */
  height: auto;
  object-fit: contain;
  display: block;
  margin: 0 auto 10px;
}

.header h1 {
  font-size: 24px;
  margin-bottom: 20px;
}

.login-form .form-group {
  margin-bottom: 15px;
  text-align: left;
}

.login-form label {
  font-size: 14px;
  margin-bottom: 5px;
  display: block;
}

.login-form input {
  width: 100%;
  padding: 10px;
  font-size: 14px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.btn-primary {
  width: 100%;
  padding: 10px;
  font-size: 16px;
  color: #fff;
  background-color: #007bff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  margin-top: 10px;
}

.btn-primary:hover {
  background-color: #0056b3;
}

.forgot-password {
  display: block;
  margin-top: 10px;
  color: #007bff;
  text-decoration: none;
}

.forgot-password:hover {
  text-decoration: underline;
}

.footer {
  margin-top: 20px;
  font-size: 12px;
  color: #777;
}

.footer a {
  color: #007bff;
  text-decoration: none;
}

.footer a:hover {
  text-decoration: underline;
}

.social-icons {
  margin-top: 10px;
}

.social-icons a {
  margin: 0 5px;
  font-size: 20px;
  color: #333;
}

.social-icons a:hover {
  color: #007bff;
}
/* no <style scoped> ou global */
.login .background{
  position: fixed;
  inset: 0;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  filter: brightness(0.9);
  z-index: 0;
}
.login .login-container{ position: relative; z-index: 1; }
.input-with-icon { position: relative; }
.input-with-icon .toggle-visibility {
  position: absolute;
  top: 50%; right: 10px;
  transform: translateY(-50%);
  border: 0; background: transparent;
  padding: 0; line-height: 1; cursor: pointer;
}
.input-with-icon .toggle-visibility i { font-size: 1.1rem; }

/* Se não estiver usando Bootstrap, garanta o respiro à direita */
.form-control.pe-5 { padding-right: 2.5rem !important; }

</style>
